
import { useSelector } from "react-redux";
import BackButton from "../../features/path/backButton";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { RootState } from "../../app/store";
import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import { Button, Card, IconCheckmarkCircle, IconChevronDown, Modal, ProgressIndicator, TextBox } from "@veneer/core";
import shareOfShelfService from "../../services/agendaApi/shareOfShelf.service";
import { Brand, Category, IBrandFilterDto } from "../../models/dto/agendaApi/IBrandFilterDto";
import { IShareOfShelfDataDto, IShareOfShelfDto, IShareOfShelfSaveDto } from "../../models/dto/agendaApi/IShareOfShelfDto";
import { useNavigate, useParams } from "react-router-dom";
import { SosOptionEnum } from "../../models/enum/AgendaApi/SosOptionEnum";
import { NumberFormatBase } from 'react-number-format';
import '../../assets/css/views/activities/shareOfShelf.css'
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";

export default function ShareOfShelf() {
    const [t] = useTranslation("global");
    const params = useParams();
    const languageId: any = useSelector((state: RootState) => state.languageId);
    const [categories, setCategories] = useState<Category[]>([]);
    const [expanded, setExpanded] = useState<string | false>(false);
    const [subExpanded, setSubExpanded] = useState<string | false>(false);
    const [shareOfShelfArray, setShareOfShelfArray] = useState<IShareOfShelfDto[]>([]);
    const [dateStart, setDateStart] = useState<any>();
    const [appointmentActivityId, setAppointmentActivityId] = useState(0);
    const [activityId, setActivityId] = useState(0);
    const [open, setOpen] = useState(false);
    const [disableButton, setDisableButton] = useState(true);
    const [sendingData, setSendingData] = useState(false);
    const [checksCategories, setChecksCategories] = useState<Map<number, boolean>>();
    const [checksSubCategories, setChecksSubCategories] = useState<Map<number, boolean>>();
    const navigate = useNavigate();

    const isFirstRender = useRef(true);


    useEffect(() => {
        getBrandsFilters(languageId.value);
        let id = Number(params.id);
        let idOfActivity = Number(params.activityId);
        setAppointmentActivityId(id);
        setActivityId(idOfActivity);
    }, [languageId])

    useEffect(() => {
        if (shareOfShelfArray.length > 0) {
            send();
        }
    }, [shareOfShelfArray])



    useEffect(() => {
        //Charge initial info
        if (isFirstRender.current && categories.length !== 0) {
            getShareOfShelf();
            isFirstRender.current = false;
        }

        //Validate checks
        const checksArraySubCategories = checksSubCategories;
        const checksArrayCategories = checksCategories;
        let validationCategory = 0;


        categories.map((category, index) => {
            category.subcategories.map((subcategory, indexS) => {
                //CHECKS
                if (subcategory.brands.some(brand => brand.valueBox === undefined || brand.valuePc === undefined)) {
                    checksArraySubCategories?.set(subcategory.id, false);
                    checksArrayCategories?.set(category.id, false);
                } else {
                    checksArraySubCategories?.set(subcategory.id, true);
                    validationCategory++;
                    if (validationCategory === category.subcategories.length - 1) {
                        checksArrayCategories?.set(category.id, true);
                    }
                }
            })
        });

        setChecksSubCategories(checksArraySubCategories);
        setChecksCategories(checksArrayCategories);


        //Validate Button 
        let validationCat = [];
        let validationSub = [];
        let validationBr = [];

        validationCat = categories.map((category, index) => {
            validationSub = category.subcategories.map((subcategory, indexS) => {
                validationBr = subcategory.brands.map((brand, indexB) => {
                    if (brand.valueBox !== undefined && brand.valueBox !== '' && brand.valuePc !== undefined && brand.valuePc !== '') {
                        return true;
                    } else if (brand.valueBox !== undefined && brand.valueBox !== '' || brand.valuePc !== undefined && brand.valuePc !== '') {
                        return false
                    } else { return null; }
                })
                if (validationBr.some(brand => brand === true)) {
                    if (validationBr.some(brand => brand === false)) {
                        return false
                    }
                    else { return true }
                } else { return null }
            })

            if (validationSub.some(item => item === true)) {
                if (validationSub.some(item => item === false)) {
                    return false
                } else { return true; }
            } else { return false; }

        });

        if (validationCat.some(item => item === true)) {
            setDisableButton(false);
        } else { setDisableButton(true); }

    }, [categories])


    const handleTextBoxChange = (categoryId: number, subCategoryId: number, brandId: number, quantity: String, option: SosOptionEnum) => {
        let categoriesArray = categories;
        let actualCat = categoriesArray.find(cat => cat.id === categoryId)?.subcategories;
        let actualSub = actualCat!.find(sub => sub.id === subCategoryId)?.brands;
        let actualBrand = actualSub!.find(brand => brand.id === brandId);
        if (option === SosOptionEnum.pc) {
            quantity === '' ? actualBrand!.valuePc = undefined : actualBrand!.valuePc = quantity.toString();
        } else {
            if(categoryId ===6){
                quantity === '' ? actualBrand!.valuePc = undefined : actualBrand!.valuePc = '0';
                quantity === '' ? actualBrand!.valueBox = undefined : actualBrand!.valueBox = quantity.toString();

            }else {
                quantity === '' ? actualBrand!.valueBox = undefined : actualBrand!.valueBox = quantity.toString();
            }
        }

        setCategories([...categoriesArray])

    };



    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleSubChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setSubExpanded(isExpanded ? panel : false);
    };

    const getShareOfShelf = () => {
        shareOfShelfService.getShareOfShelf()
            .then(r => {
                fillShareOfShelf(r)
            })
    }

    const getBrandsFilters = (languageId: number) => {
        shareOfShelfService.getBrandsFilters(languageId, appointmentActivityId)
            .then(r => {
                groupByType(r);
                setDateStart(new Date())
            })
    }

    const groupByType = (data: IBrandFilterDto[]) => {
        const categoriesMap = new Map<string, Category>();
        const checksArraySubCategories = new Map<number, boolean>();
        const checksArrayCategories = new Map<number, boolean>();
        data.forEach((row: IBrandFilterDto) => {
            const categoryKey = row.category;
            const subcategoryKey = row.subCategory;
            const brand: Brand = { id: row.brandId, name: row.brand, valuePc: undefined, valueBox: undefined };
            let category = categoriesMap.get(categoryKey);
            if (!category) {
                category = { id: row.categoryId, name: categoryKey, subcategories: [] };
                categoriesMap.set(categoryKey, category);
                checksArrayCategories.set(row.categoryId, false);
            }
            let subcategory = category.subcategories.find(s => s.name === subcategoryKey);
            if (!subcategory) {
                subcategory = { id: row.subCategoryId, name: subcategoryKey, brands: [] };
                category.subcategories.push(subcategory);
                checksArraySubCategories.set(row.subCategoryId, false);
            }
            subcategory.brands.push(brand);
        });
        const categories = Array.from(categoriesMap.values());
        setCategories(categories);
        setChecksSubCategories(checksArraySubCategories);
        setChecksCategories(checksArrayCategories);
    }

    const fillShareOfShelf = (data: IShareOfShelfDataDto[]) => {
        let categoriesTemp = categories;
        data.map((item, index) => {
            categoriesTemp.map((category, indexCategory) => {
                let subcategoryTemp = category.subcategories.find(subcategory => subcategory.id === item.categoryID);
                if (subcategoryTemp) {
                    let brandTemp = subcategoryTemp.brands.find(brand => brand.id === item.brandID)
                    if (brandTemp) {
                        brandTemp.valuePc = String(item.faces);
                        brandTemp.valueBox = String(item.boxes);
                    }
                }
            })
        })
        setCategories([...categoriesTemp])
    }

    const saveInformation = () => {
        setSendingData(true);
        let sos: IShareOfShelfDto[] = [];
        categories.map(c => {
            c.subcategories.map(s => {
                s.brands.map(b => {
                    if (b.valueBox || b.valuePc) {
                        b.valueBox = b.valueBox === undefined ? '0' : b.valueBox;
                        b.valuePc = b.valuePc === undefined ? '0' : b.valuePc;
                        sos.push({ faces: Number(b.valuePc), boxes: Number(b.valueBox), appointmentActivityId: appointmentActivityId, brandId: b.id, categoryId: c.id, dateStart: dateStart, dateEnd: new Date(), subCategoryId: s.id, status: 'Completed' });
                    }
                })
            })
        });
        setShareOfShelfArray(sos);
    }

    const send = () => {
        let sosIn: IShareOfShelfSaveDto[] = [];
        for (let i = 0; i < shareOfShelfArray.length; i++) {
            sosIn.push({
                id_categories: shareOfShelfArray[i].subCategoryId,
                date_end: shareOfShelfArray[i].dateEnd,
                date_start: shareOfShelfArray[i].dateStart,
                id_brand: shareOfShelfArray[i].brandId,
                status: "Completed",
                id_appointment_activity: shareOfShelfArray[i].appointmentActivityId,
                boxes: shareOfShelfArray[i].boxes,
                faces: shareOfShelfArray[i].faces
            })

        }
        shareOfShelfService.saveInformation(sosIn)
            .then(r => {
                setOpen(true);
                resetArrays();
                setSendingData(false);
            })
    }

    const resetArrays = () => {
        const checksArraySubCategories = checksSubCategories;
        const checksArrayCategories = checksCategories;
        checksArraySubCategories?.clear();
        checksArrayCategories?.clear();
        let arrayCategories: Category[] = categories.map(c => {
            c.subcategories.map(s => {
                s.brands.map(b => {
                    b.valueBox = undefined;
                    b.valuePc = undefined;
                    return b;
                })
                return s;
            })
            return c;
        });
        setCategories(arrayCategories);
        setChecksCategories(checksArrayCategories);
        setChecksSubCategories(checksArraySubCategories);
        setShareOfShelfArray([]);
        setDisableButton(true);
    }

    const close = () => {
        navigate(-1);
    }

    return (
        <div>
            <div style={{ padding: '20px' }}>
                <BackButton route={BreadCrumbsEnum.ShareOfShelf} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                <h4>{t("header.shareOfShelf")}</h4>
                <div style={{ padding: '20px' }}>
                    {
                        categories?.length === 0
                            ? <div className="container">
                                <div className="vertical-center">
                                    <ProgressIndicator
                                        appearance="circular"
                                        behavior="indeterminate"
                                    />
                                </div>
                            </div>
                            :
                            <div>
                                <div style={{ textAlign: "right", marginBottom: '2%' }}>
                                    <Button disabled={disableButton} loading={sendingData} onClick={saveInformation}>
                                        {t("modal.saveTitleInfo")}
                                    </Button>
                                </div>
                                <Card appearance="dropShadow"
                                    style={{ padding: '2%', height: '55vh', overflow: 'auto' }}
                                    content={
                                        <div>
                                            {
                                                categories.map((category, index) =>
                                                    <Accordion key={index} style={{
                                                        borderRadius: '12px', borderColor: '#ebebeb', backgroundColor: 'transparent', borderStyle: 'solid', borderWidth: ' 0px 1px 0px',
                                                        boxSizing: 'border-box', borderTopWidth: '1px', flexDirection: 'column', marginBottom: '15px', overflow: 'hidden', borderBottomWidth: '1px'
                                                    }} expanded={expanded === 'panel-' + category.id} onChange={handleChange('panel-' + category.id)}>
                                                        <AccordionSummary
                                                            expandIcon={<IconChevronDown />}
                                                            aria-controls="panel2a-content"
                                                            id="panel2a-header"
                                                        >
                                                            {category.name}&nbsp;&nbsp;
                                                            {
                                                                checksCategories?.get(category.id)
                                                                    ?
                                                                    <IconCheckmarkCircle color="colorLightGreen6" filled></IconCheckmarkCircle>
                                                                    :
                                                                    <></>
                                                            }
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            {
                                                                category.subcategories.map((subCategory, i) =>
                                                                    <Accordion key={i} style={{
                                                                        borderRadius: '12px', borderColor: '#ebebeb', backgroundColor: 'transparent', borderStyle: 'solid', borderWidth: ' 0px 1px 0px',
                                                                        boxSizing: 'border-box', borderTopWidth: '1px', flexDirection: 'column', marginBottom: '15px', overflow: 'hidden', borderBottomWidth: '1px'
                                                                    }} expanded={subExpanded === 'panel-' + category.id + subCategory.id} onChange={handleSubChange('panel-' + category.id + subCategory.id)}>
                                                                        <AccordionSummary
                                                                            expandIcon={<IconChevronDown />}
                                                                            aria-controls="panel2a-content"
                                                                            id="panel2a-header">
                                                                            {subCategory.name}&nbsp;&nbsp;
                                                                            {
                                                                                checksSubCategories?.get(subCategory.id)
                                                                                    ?
                                                                                    <IconCheckmarkCircle color="colorLightGreen6" filled />
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </AccordionSummary>
                                                                        <Divider />
                                                                        <AccordionDetails>
                                                                            <table className="tableSos">
                                                                                <thead className="theadSos">
                                                                                    <tr className="trSos">
                                                                                        <th className="thSos">{t('header.brand')}</th>
                                                                                        <th className="thSos">{t('header.products')}</th>
                                                                                        <th className="thSos">{t('header.productBox')}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody className="tbodySos">
                                                                                    {category.id === 6 ? <>{
                                                                                        subCategory.brands.map((brand, brandIndex) =>
                                                                                            <tr key={brandIndex} className="trSos">
                                                                                                <td className="tdSos tdTextFieldNumberSos">{brand.name}</td>
                                                                                                <td className="tdSos tdTextFieldNumberSos"><TextBox id="textPc" readOnly value={brand.valuePc} className="textFieldNumberSos" inputComponent={NumberFormatBase} maxLength={3} onChange={(e) => handleTextBoxChange(category.id, subCategory.id, brand.id, e, SosOptionEnum.pc)} /></td>
                                                                                                <td className="tdSos tdTextFieldNumberSos"><TextBox id="textBoxes" value={brand.valueBox} className="textFieldNumberSos" inputComponent={NumberFormatBase} maxLength={3} onChange={(e) => handleTextBoxChange(category.id, subCategory.id, brand.id, e, SosOptionEnum.box)} /></td>
                                                                                            </tr>
                                                                                        )
                                                                                    }</>
                                                                                        : <>{
                                                                                            subCategory.brands.map((brand, brandIndex) =>
                                                                                                <tr key={brandIndex} className="trSos">
                                                                                                    <td className="tdSos tdTextFieldNumberSos">{brand.name}</td>
                                                                                                    <td className="tdSos tdTextFieldNumberSos"><TextBox id="textPc" value={brand.valuePc} className="textFieldNumberSos" inputComponent={NumberFormatBase} maxLength={3} onChange={(e) => handleTextBoxChange(category.id, subCategory.id, brand.id, e, SosOptionEnum.pc)} /></td>
                                                                                                    <td className="tdSos tdTextFieldNumberSos"><TextBox id="textBoxes" value={brand.valueBox} className="textFieldNumberSos" inputComponent={NumberFormatBase} maxLength={3} onChange={(e) => handleTextBoxChange(category.id, subCategory.id, brand.id, e, SosOptionEnum.box)} /></td>
                                                                                                </tr>
                                                                                            )
                                                                                        }</>

                                                                                    }
                                                                                </tbody>
                                                                            </table>
                                                                        </AccordionDetails>
                                                                    </Accordion>
                                                                )
                                                            }
                                                        </AccordionDetails>
                                                    </Accordion>
                                                )
                                            }
                                        </div>
                                    }
                                >
                                </Card>
                            </div>

                    }
                </div>
                <Modal
                    align="start"
                    id="modal-id"
                    show={open}
                    onClose={() => close()}
                    footer={(
                        <div style={{ textAlign: 'center' }}>
                            <Button style={{ marginRight: 4 }} onClick={close}>{t('header.confirm')}</Button>
                        </div>
                    )}
                    title={t("header.information")}>
                    <p>
                        {t("modal.saveSuccess")}
                    </p>
                </Modal>
            </div >
        </div >
    )
}